import { stores, languages } from '../translations';
import { useCurrentStore } from './useCurrentStore';

/**
 * Хук для получения доступных языков для текущего магазина
 * @returns {string[]} - массив доступных языков
 */
export const useAvailableLanguages = () => {
  const currentStore = useCurrentStore();

  switch (currentStore) {
    case stores.ru:
      return [languages.ru];
    case stores.kz:
      return [languages.ru, languages.kz];
    case stores.ae:
      return [languages.ru, languages.en, languages.ar];
    case stores.qa:
    case stores.sa:
      return [languages.en, languages.ar];
    default:
      return [languages.ru];
  }
};
